import React, { useMemo } from "react";
import { injectIntl } from "react-intl";
import useQueryResponse from "../../../lib/hooks/useQueryResponse";

import Loader from "../../../components/Common/Loader/Loader";
import ManageSubCategoryList from "../../../components/ManageSubCategory/ManageSubCategoryList/ManageSubCategoryList";
import NotFound from "../../../components/NotFound/NotFound";

import messages from "../../../locale/messages";

import getActiveSubCategory from './getActiveSubCategory.graphql';
import { getUserCategoryQuery } from "../../../lib/graphql";
import getCategoryPricing from "./getCategoryPricing.graphql";
import getUser from "./getUser.graphql"
import getCategory from './getCategory.graphql';


const ManageSubCategory = ({ categoryId, profileId }) => {
    const { data: mainCategory, loading: mainCategoryLoading } = useQueryResponse({
        query: getCategory,
        variables: {
            id: categoryId
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { data: userDetails, loading: userDetailsLoading } = useQueryResponse({
        query: getUser,
        variables: {
            id: profileId,
            userType: 2
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { data: getPricingDetails, loading: pricingDetailsLoading } = useQueryResponse({
        query: getCategoryPricing,
        variables: {
            categoryId: categoryId
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { data: userCategoryDetails, loading: userCategoryLoading } = useQueryResponse({
        query: getUserCategoryQuery,
        variables: {
            profileId: profileId
        },
        fetchPolicy: 'network-only',
    })
    const { data: subCategoryDetails, loading, refetch: refetchSubCategories } = useQueryResponse({
        query: getActiveSubCategory,
        variables: {
            id: categoryId,
            searchList: ''
        },
        fetchPolicy: 'network-only'
    })
    let preferredCurrency = useMemo(() => {
        if (userDetails?.getUser?.status === 200) {
            return userDetails?.getUser?.result?.profile?.preferredCurrency
        }
        return null
    }, [userDetails])

    let categoryName = useMemo(() => {
        if (mainCategory?.getCategory?.status == 200) {
            return categoryName = mainCategory?.getCategory?.result?.name
        }
        return null
    }, [mainCategory])

    if (!userDetailsLoading && !userDetails?.getUser?.result) {
        return <NotFound title={formatMessage(messages.pageNotFound)} />
    } else {
        return (
            <Loader type="page" show={loading}>
                {
                    !loading && !userCategoryLoading && !pricingDetailsLoading && !userDetailsLoading &&
                    !mainCategoryLoading &&
                    <ManageSubCategoryList
                        subCategoryDetails={{ ...subCategoryDetails, refetch: refetchSubCategories }}
                        categoryId={categoryId}
                        profileId={profileId}
                        userCategoryDetails={userCategoryDetails}
                        categoryPricingDetails={getPricingDetails}
                        currency={preferredCurrency}
                        categoryName={categoryName}
                    />

                }
            </Loader>
        )
    }
}
export default injectIntl(ManageSubCategory);
